import { Divider } from 'antd'
import { FC } from 'react'
import { FullMeetingFragment, ScoreGoalDto } from '../../../types'
import { AvatarData } from '../appraisal-flow/shared/appraisal-types'
import { AppraisalContextType } from '../AppraisalTypes'
import { ScoreGoalForm } from './ScoreGoalForm'

type EvaluationContentComponentProps = {
  type: AppraisalContextType
  goals: ScoreGoalDto[]
  meeting: FullMeetingFragment
  validateInputs?: boolean
  update: (newScoreGoal: ScoreGoalDto) => void
}

export const EvaluationContentComponent: FC<EvaluationContentComponentProps> = ({ type, goals, meeting, validateInputs, update }) => {
  let reviewerAvatar: AvatarData
  if (meeting.reviewer) {
    reviewerAvatar = {
      id: meeting.reviewer.id,
      legalFirstName: meeting.reviewer.firstName,
      legalLastName: meeting.reviewer.lastName,
    }
  }
  return (
    <>
      {goals.map((score: ScoreGoalDto, index: number) => (
        <div id={score.viewId} key={score.viewId}>
          <ScoreGoalForm
            updateFn={update}
            score={score}
            employeeAvatar={meeting.employee as AvatarData}
            reviewerAvatar={reviewerAvatar}
            type={type}
            focus={index === 0}
            validateInputs={validateInputs}
          />
          {index < goals.length - 1 && <Divider />}
        </div>
      ))}
    </>
  )
}
